export default __webpack_public_path__ + "static/media/circleRepliconLogoNew.a2886236.svg";